const prototypes = {
  getWidgetUuid: function() {
    return this.id || this.node.getAttribute('data-8select-widget-uuid')
  },
  getApiId: function() {
    if (this.window._8select.config.demoMode.isActive()) {
      return this.window._8select.config.demoMode.apiId
    }

    if (this.widgetConfiguration.apiUrlIncludesApiId) {
      return ''
    }

    return this.widgetConfiguration.apiId ? this.widgetConfiguration.apiId : window._8select.config.apiId
  },
  getIdentifier: function() {
    if (this.window._8select.config.demoMode.isActive()) {
      return this.window._8select.config.demoMode.sku
    }

    if (this.node.hasAttribute('data-sku') === false && this.node.hasAttribute('data-identifier') === false) {
      return undefined
    }

    const identifierRaw = this.node.getAttribute('data-sku') || this.node.getAttribute('data-identifier')
    const identifier = encodeURIComponent(identifierRaw)

    if (this.widgetConfiguration.hooks && typeof this.widgetConfiguration.hooks.getIdentifier === 'function') {
      return this.widgetConfiguration.hooks.getIdentifier(identifier)
    }
    if (typeof this.window._8select.config.hooks.getSku === 'function') {
      return this.window._8select.config.hooks.getSku(identifier)
    }
    if (typeof this.window._8select.config.hooks.getIdentifier === 'function') {
      return this.window._8select.config.hooks.getIdentifier(identifier)
    }

    return identifier
  },
  getSetId: function() {
    if (this.window._8select.config.demoMode.isActive()) {
      return this.window._8select.config.demoMode.setId
    }

    if (this.node.hasAttribute('data-set-id') === false) {
      return undefined
    }

    const setId = encodeURIComponent(this.node.getAttribute('data-set-id'))

    if (typeof this.window._8select.config.hooks.getSetId === 'function') {
      return this.window._8select.config.hooks.getSetId(setId)
    }

    return setId
  },
  hide: function() {
    this.node.style.display = 'none'
  },
  show: function() {
    if (this.container !== undefined) {
      this.container.style.display = 'block'
    }
    this.node.style.display = 'block'
  },
}

export default prototypes
